import {
    addDays,
    endOfDay,
    startOfDay,
    startOfMonth,
    endOfMonth,
    addMonths,
    startOfWeek,
    endOfWeek,
    isSameDay,
    differenceInCalendarDays,
    addQuarters,
    startOfQuarter,
    endOfQuarter,
    addYears,
    startOfYear,
    endOfYear
  } from 'date-fns';
  
  const defineds = {
    startOfWeek: startOfWeek(new Date()),
    endOfWeek: endOfWeek(new Date()),
    startOfLastWeek: startOfWeek(addDays(new Date(), -7)),
    endOfLastWeek: endOfWeek(addDays(new Date(), -7)),
    startOfToday: startOfDay(new Date()),
    endOfToday: endOfDay(new Date()),
    startOfYesterday: startOfDay(addDays(new Date(), -1)),
    endOfYesterday: endOfDay(addDays(new Date(), -1)),
    startOfMonth: startOfMonth(new Date()),
    endOfMonth: endOfMonth(new Date()),
    startOfLastMonth: startOfMonth(addMonths(new Date(), -1)),
    endOfLastMonth: endOfMonth(addMonths(new Date(), -1)),    
    startOfQuarter: startOfQuarter(new Date()),
    endOfQuarter: endOfQuarter(new Date()),
    startOfLastQuarter: startOfQuarter(addQuarters(new Date(), -1)),
    endOfLastQuarter: endOfQuarter(addQuarters(new Date(), -1)),  
    startOfYear: startOfYear(new Date()),
    endOfYear: endOfYear(new Date()),
    startOfLastYear: startOfYear(addYears(new Date(), -1)),
    endOfLastYear: endOfYear(addYears(new Date(), -1)),

  };
  
  const staticRangeHandler = {
    range: {},
    isSelected(range) {
      const definedRange = this.range();
      return (
        isSameDay(range.startDate, definedRange.startDate) &&
        isSameDay(range.endDate, definedRange.endDate)
      );
    },
  };
  
  export function createStaticRanges(ranges) {
   
    return ranges.map(range => ({ ...staticRangeHandler, ...range }));
  }
  
  export const rangos = createStaticRanges([
    {
      label: 'Hoy',
      range: () => ({
        startDate: defineds.startOfToday,
        endDate: defineds.endOfToday
      })
    },
    {
      label: 'Ayer',
      range: () => ({
        startDate: defineds.startOfYesterday,
        endDate: defineds.endOfYesterday
      })
    },
  
    {
      label: 'Esta semana',
      range: () => ({
        startDate: defineds.startOfWeek,
        endDate: defineds.endOfWeek
      }),
    },
    {
      label: 'La semana pasada',
      range: () => ({
        startDate: defineds.startOfLastWeek,
        endDate: defineds.endOfLastWeek
      }),
    },
    {
      label: 'Este mes',
      range: () => ({
        startDate: defineds.startOfMonth,
        endDate: defineds.endOfMonth
      }),
    },
    {
      label: 'El mes pasado',
      range: () => ({
        startDate: defineds.startOfLastMonth,
        endDate: defineds.endOfLastMonth
      }),
    },
    {
      label: 'Este trimestre',
      range: () => ({
        startDate: defineds.startOfQuarter,
        endDate: defineds.endOfQuarter
      }),
    },
    {
      label: 'El trimestre pasado',
      range: () => ({
        startDate: defineds.startOfLastQuarter,
        endDate: defineds.endOfLastQuarter
      }),
    },
    {
      label: 'Este año',
      range: () => ({
        startDate: defineds.startOfYear,
        endDate: defineds.endOfYear
      }),
    },
    {
      label: 'El año pasado',
      range: () => ({
        startDate: defineds.startOfLastYear,
        endDate: defineds.endOfLastYear
      }),
    },
  ]);
  
  export const defaultInputRanges = [
    {
      label: 'dias hasta hoy',
      range(value) {
        return {
          startDate: addDays(defineds.startOfToday, (Math.max(Number(value), 1) - 1) * -1),
          endDate: defineds.endOfToday,
        };
      },
      getCurrentValue(range) {
        if (!isSameDay(range.endDate, defineds.endOfToday)) return '-';
        if (!range.startDate) return '∞';
        return differenceInCalendarDays(defineds.endOfToday, range.startDate) + 1;
      },
    },
    {
      label: 'dias a partir de hoy',
      range(value) {
        const today = new Date();
        return {
          startDate: today,
          endDate: addDays(today, Math.max(Number(value), 1) - 1),
        };
      },
      getCurrentValue(range) {
        if (!isSameDay(range.startDate, defineds.startOfToday)) return '-';
        if (!range.endDate) return '∞';
        return differenceInCalendarDays(range.endDate, defineds.startOfToday) + 1;
      },
    },
  ];